import { GET_LIST_AKTIVITAS_GENERAL } from "shared/constants/ActionTypes";

const INIT_STATE = {
    aktivitas: {
        list: {
            results: []
        }
    }
};

const logbookReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_AKTIVITAS_GENERAL: {
            return {
                ...state,
                aktivitas: {
                    ...state.aktivitas,
                    list: action.payload
                }
            }
        }
        default:
            return state;
    }
};
export default logbookReducer;
